"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
var menuButton = {
  requires: 'button,menu',
  onLoad: function onLoad() {
    var clickFn = function clickFn(editor) {
      var _ = this._,
          menu = _.menu; // Do nothing if this button is disabled.

      if (_.state === window.CKEDITOR.TRISTATE_DISABLED) {
        return;
      }

      if (_.on && menu) {
        menu.hide();
        return;
      }

      _.previousState = _.state; // Check if we already have a menu for it, otherwise just create it.

      if (!menu) {
        menu = _.menu = new window.CKEDITOR.menu(editor, {
          panel: {
            className: 'cke_menu_panel',
            attributes: {
              'aria-label': editor.lang.common.options
            },
            css: [window.CKEDITOR.skin.getPath('editor')].concat(window.CKEDITOR.config.contentsCss)
          }
        });
        menu.onHide = window.CKEDITOR.tools.bind(function () {
          var modes = this.command ? editor.getCommand(this.command).modes : this.modes;
          this.setState(!modes || modes[editor.mode] ? _.previousState : window.CKEDITOR.TRISTATE_DISABLED);
          _.on = 0;
        }, this); // Initialize the menu items at this point.

        if (this.onMenu) {
          menu.addListener(this.onMenu);
        }
      }

      this.setState(window.CKEDITOR.TRISTATE_ON);
      _.on = 1; // This timeout is needed to give time for the panel get focus
      // when JAWS is running. (https://dev.ckeditor.com/ticket/9842)

      setTimeout(function () {
        menu.show(window.CKEDITOR.document.getById(_.id), 4);
      }, 0);
    };
    /**
     * @class
     * @extends CKEDITOR.ui.button
     * @todo
     */


    window.CKEDITOR.ui.menuButton = window.CKEDITOR.tools.createClass({
      base: window.CKEDITOR.ui.button,

      /**
       * Creates a menuButton class instance.
       *
       * @constructor
       * @param Object definition
       * @todo
       */
      $: function $(definition) {
        this.base(definition);
        this.hasArrow = 'menu';
        this.click = clickFn;
      },
      statics: {
        handler: {
          create: function create(definition) {
            return new window.CKEDITOR.ui.menuButton(definition);
          }
        }
      }
    });
  },
  beforeInit: function beforeInit(editor) {
    /**
     * Button UI element.
     *
     * @readonly
     * @property {String} [='menubutton']
     * @member CKEDITOR
     */
    window.CKEDITOR.UI_MENUBUTTON = 'menubutton';
    editor.ui.addHandler(window.CKEDITOR.UI_MENUBUTTON, window.CKEDITOR.ui.menuButton.handler);
  }
};
var _default = menuButton;
exports.default = _default;